import script from "./GroupDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupDevice.vue?vue&type=script&setup=true&lang=js"

import "./GroupDevice.vue?vue&type=style&index=0&id=484b1910&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-484b1910"]])

export default __exports__